module.exports = __webpack_public_path__ + "img/9791188299041.8e816635.jpg";